// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e0c3575d","453":"d1112624","732":"53621276","977":"c49e0ef6"}[chunkId] + ".chunk.js";
};